<template>
    <div>
        <v-server-table :name="tableName" :ref="tableName" url="/safety-meetings/list" :columns="columns" :options="options">

            <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
                <div class="clearfix d-md-none d-block"></div>

                <div v-if="allowFilterSaving" class="float-left mr-1">
                    <user-filters ref="meetingSavedFilters" assetType="SafetyMeeting" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
                </div>

                <div class="float-left">
                    <table-filters-2 ref="meetingTableFilters"
                        filterUrl="/safety-meetings/filters"
                        v-bind:filters="filters"
                        :emptyFilters="filterDefs"
                        :filterKey="filterKey"
                        @filtersChanged="refreshTableData"
                        @filtersCleared="filtersCleared"
                        v-show="!dashboardFilters">
                        <template slot-scope="slotProps">
                            <div class="d-inline-block">
                                <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                            </div>
                            <div style="display: inline-block; width: 300px;">
                                <jobsite-select :forFilters="true" :selectedValues="slotProps.filters['safety_meetings.JobsiteId']" v-on:vselected="onJobSiteSelectUpdate" />
                            </div>
                            <div class="d-inline-block">
                                <date-range-selector buttonTitle="Meeting Date" v-model="slotProps.filters['safety_meetings.meeting_date']" />
                            </div>
                            <div class="d-inline-block">
                                <b-form-select v-model="slotProps.filters['safety_meetings.is_subcontractor']" :options="isSubMeetingOptions"></b-form-select>
                            </div>
                            <div class="d-inline-block">
                                <b-form-select v-model="slotProps.filters['safety_meetings.meeting_status']" :options="meetingStatusOptions"></b-form-select>
                            </div>
                        </template>
                    </table-filters-2>
                </div>

                <button type="button" class="btn btn-outline-success ml-2" @click="exportTable()" :disabled="exportingTable">
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </button>

                <div class="clearfix d-md-none d-block"></div>
            </div>

            <template slot="safety_meeting_id" slot-scope="props">
                <router-link :to="`/safety-meetings/view/${props.row.safety_meeting_id}`" title="View Safety Meeting" class="btn btn-sm btn-secondary">
                    View
                </router-link>
                <router-link  :to="`/safety-meetings/edit/${props.row.safety_meeting_id}`" title="Edit Safety Meeting" class="btn btn-sm btn-light">
                    <i class="fa fa-edit"></i> Edit
                </router-link>
            </template>

            <template slot="meeting_title" slot-scope="props">
                <router-link :to="`/safety-meetings/view/${props.row.safety_meeting_id}`" title="View Safety Meeting" v-if="props.row.meeting_title">
                    {{ props.row.meeting_title }}
                </router-link>
            </template>

            <template slot="meeting_status" slot-scope="props">
                <label class="badge badge-success" v-if="props.row.meeting_status == 'Closed'">Closed</label>
                <label class="badge badge-danger" v-else>Open</label>
            </template>

            <router-link slot="meeting_date" slot-scope="props" :to="`/safety-meetings/view/${props.row.safety_meeting_id}`" title="View Safety Meeting">
                {{ props.row.meeting_date | moment("MM/DD/YYYY") }}
            </router-link>

            <template slot="DivisionName" slot-scope="props">
                {{ props.row.division_code }} - {{ props.row.DivisionName }}
            </template>

            <template slot="subcontractor_name" slot-scope="props">
                <router-link :to="`/subcontractors/view/${props.row.subcontractor_id}`" title="View Subcontractor" v-if="props.row.subcontractor_id">
                    {{ props.row.subcontractor_name }}
                </router-link>
            </template>

            <template slot="FirstName" slot-scope="props">
                <user-name :user="props.row" />
            </template>

            <!-- <template slot="child_row" slot-scope="props">
                <div class="form-group">
                    <label class="text-muted">Meeting Notes:</label>
                    <div v-html="props.row.meeting_notes"></div>
                </div>
            </template> -->

        </v-server-table>
    </div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        //props: ['assetType', 'assetId', 'allowFilterSaving'],
        props: {
            assetType: {
                type: String,
                default: null,
            },

            assetId: {
                //type: Number,
                default: null,
            },

            allowFilterSaving: {
                //type: Boolean,
                default: false,
            },

            filterId: {
                type: Number,
                default: null,
            },

            dashboardFilters: {
                type: Object,
                default(){
                    return null;
                },
            },

            tableConfig: {
                type: Object,
                default(){
                    return null;
                },
            },
        },

        data: function() {
            return {
                exportingTable: false,
                userTimezone: this.$store.state.user.timezone,
                tableName: 'safetyMeetingTable',

                filterDefs: {
                    'safety_meetings.JobsiteId' : null,
                    'safety_meetings.meeting_date' : '',
                    'safety_meetings.meeting_status' : null,
                    'jobsite.DivisionId': [],
                    'safety_meetings.is_subcontractor': null,
                },

                filterKey: 'meetingFilters',
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            columns(){
                var cols = ['safety_meeting_id', 'meeting_title', 'meeting_status', 'meeting_date', 'DivisionName', 'JobsiteNumber', 'JobsiteName', 'FirstName', 'subcontractor_name'];

                //If asset is Sub, hide that column
                if(this.assetType == 'Subcontractor')
                {
                    cols = ['safety_meeting_id', 'meeting_title', 'meeting_status', 'meeting_date', 'DivisionName', 'JobsiteNumber', 'JobsiteName', 'FirstName'];
                }

                //Send it
                return cols;
            },

            isSubMeetingOptions(){
                //Send it
                return [
                    {value: null, text: '-- All Meetings (Subcontractor) --'},
                    {value: false, text: 'Hide Subcontractor Meetings'},
                    {value: true, text: 'Only Subcontractor Meetings'},
                ];
            },

            meetingStatusOptions(){
                //Send it
                return [
                    {value: null, text: '-- All Meetings (Status) --'},
                    {value: 'Open', text: 'Open'},
                    {value: 'Closed', text: 'Closed'},
                ];
            },

            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        safety_meeting_id: 'Actions',
                        meeting_title: 'Title',
                        meeting_status: 'Status',
                        meeting_date: 'Date',
                        DivisionName: 'Division',
                        JobsiteName: 'Jobsite',
                        JobsiteNumber: 'Jobsite#',
                        FirstName: 'Creator',
                        subcontractor_name: 'Subcontractor',
                    },
                    saveState: this.allowFilterSaving,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: (this.allowFilterSaving ? this.$root.getVisibleColumnsFromState(this.tableName) : false),
                    sendInitialRequest: (this.filterId ? false : true),
                    orderBy: {
                        ascending: false,
                        column: 'safety_meetings.meeting_date',
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('safetyMeetingListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Set the filters
                        //data.filters = filterExtractor.extractFilters(this.filters);
                        data.filters = (this.dashboardFilters ? filterExtractor.extractFilters(this.dashboardFilters) : filterExtractor.extractFilters(this.filters));

                        // //INclude the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'safety_meeting_id',
                };
            },
        },

        methods: {

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the payload
                var payload = {
                    filters: filterExtractor.extractFilters(this.filters),
                    query: (this.$refs.safetyMeetingTable.getRequestParams()).query,
                    orderBy: this.$refs.safetyMeetingTable.options.orderBy.column,
                    ascending: this.$refs.safetyMeetingTable.options.orderBy.ascending,
                    table: 'safetyMeetingTable',
                    columns: this.$refs.safetyMeetingTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                };

                //Send it
                this.$http.get('/safety-meetings/list?export=true', payload)
                    .then(response => {
                        //Open the new window
                        window.open(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Safety Meetings');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },

            refreshTableData(filters) {
                //Set the data
                this.$refs.safetyMeetingTable.setPage(1);
                //this.$refs.safetyMeetingTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.meetingTableFilters.resetColVis(this.$refs.safetyMeetingTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.meetingSavedFilters.setFilterParams(this.$refs.safetyMeetingTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.meetingTableFilters.setColVis(this.$refs.safetyMeetingTable);
            },
        },

        mounted(){
            //Check for Staring Filters
            if(!this.dashboardFilters)
            {
                //Set it
                //this.$refs.inspTableFilters.setFilters(this.dashboardFilters);

                //Check for a saved filter
                this.checkForAppliedFilter();

                //Check for Filter ID
                if(this.filterId)
                {
                    this.$refs.meetingSavedFilters.setSavedFilter(this.filterId);
                }
            }

            //Check for Table Config
            if(this.tableConfig)
            {
                //Set it
                this.$refs.meetingTableFilters.setColVisFromSavedFilter(this.$refs.safetyMeetingTable, this.tableConfig);
            }
        }
    }
</script>
